import { logger } from '@/services/logger';

const encoder = new TextDecoder('utf-8');
export function decode(buffer?: BufferSource): Record<string, string> | undefined {
    if (!buffer) return;

    const decoded = encoder.decode(buffer);

    if (decoded) {
        try {
            return JSON.parse(decoded || '{}');
        } catch (e) {}
    }
}

export function endStream(mediaSource: MediaSource, read: any, setError: (error: string) => void) {
    try {
        mediaSource.endOfStream();
    } catch (e) {
        const decoded = decode(read.value);
        console.log('endStream', decoded);

        if (!decoded?.kind) {
            throw e;
        }

        logger.error(decoded);
        setError(decoded.kind.toLowerCase());
    }
}

export async function getReader(
    url: string,
    voiceid: string,
    text: string,
    accessToken: string,
    signal: AbortSignal,
    setError?: (error: any) => void,
    modelId?: string,
    speed?: string,
    style?: string,
    stability?: number,
    similarityBoost?: number
) {
    const body = modelId
        ? JSON.stringify({ voiceid, text, modelId, style, stability, similarityBoost, speed })
        : JSON.stringify({ voiceid, text, speed, style, stability, similarityBoost });
    const request = await fetch(url, {
        method: 'POST',
        body,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        signal,
    }).catch(_ => setError?.('no-connection'));

    return request?.body?.getReader();
}

export function concatArrayBuffers(arrayBuffers: ArrayBuffer[]) {
    let totalLength = 0;
    for (const buffer of arrayBuffers) {
        totalLength += buffer.byteLength;
    }

    const concatenatedArrayBuffer = new ArrayBuffer(totalLength);
    const view = new Uint8Array(concatenatedArrayBuffer);
    let offset = 0;

    for (const buffer of arrayBuffers) {
        const bufferView = new Uint8Array(buffer);
        view.set(bufferView, offset);
        offset += buffer.byteLength;
    }

    return concatenatedArrayBuffer;
}
